<template>
  <el-main>
    <div class="member_details">
      <div class="avatar">
        <!-- <el-image :src="$imgUrl + memberInfoRes.member_photo" fit="cover">
          
        </el-image> -->
        <img v-if="memberInfoRes.member_photo" :src="$imgUrl + memberInfoRes.member_photo" />
        <div v-else class="image-slot">
            <p
              class="bg-title"
              :style="
                'background-color:' +
                colors[Math.floor(Math.random() * colors.length)]
              "
            >
              {{ memberName[memberName.length - 1] }}
            </p>
          </div>
        <h5>{{ memberInfoRes.really_name }}</h5>
        <span>{{ memberInfoRes.position }}</span>
      </div>

      <div class="info_list">
        <div
          class="info_list_item"
          v-for="item in infoIconList"
          :key="item.infoName"
        >
          <el-row v-if="item[item.contentType]">
            <el-col :span="isPc ? 5 : 9">
              <em :style="'background-image:url(' + item.icon + ');'"></em>
              <label>{{ item.menuName }}</label>
            </el-col>
            <el-col
              :span="isPc ? 19 : 15"
              v-if="item.contentType !== 'tshBusinessCompany'"
            >
              <span>{{ item[item.contentType] }} <strong v-if="item.contentType == 'mobilePhone'" :class="{'red':item.contentType == 'mobilePhone'&&!item[item.contentType]}">{{item.contentType == 'mobilePhone'&&item[item.contentType]?'（已驗證）':'（未驗證）'}}</strong></span>
            </el-col>
          </el-row>
        </div>
        <div class="info_list_item" v-if="memberInfoRes.tshMemberSubAssoList&&memberInfoRes.tshMemberSubAssoList.length>0">
          <el-row>
            <el-col :span="isPc ? 5 : 9">
              <em
                :style="
                  'background-image:url(' +
                  require('../assets/images/enterprises-menu05.png') +
                  ');'
                "
              ></em>
              <label>所属地区：</label>
            </el-col>
            <el-col :span="isPc ? 19 : 15">
              <span v-for="item in memberInfoRes.tshMemberSubAssoList" :key="item.ass_area_id">{{item.area}}</span>
            </el-col>
          </el-row>
        </div>
      </div>
      <h4 class="title01" v-if="memberCompanyList.length > 0">名下企業:</h4>
      <el-row :gutter="20">
        <el-col
          :span="isPc ? 12 : 24"
          v-for="item in memberCompanyList"
          :key="item.company_id"
        >
          <div class="grid-content" @click="fnToCompany(item.company_id)">
            <el-image :src="$imgUrl + item.company_logo" fit="cover">
              <div slot="error" class="image-slot">
                <p class="bg-title" v-html="item.company_code[0]"></p>
              </div>
            </el-image>
            <div class="company_title">
              <h3 v-html="item.company_name"></h3>
              <div class="company_info">
                <div class="company_tel">
                  <em></em>
                  <span>{{ item.phone }}</span>
                </div>
                <div class="company_field">
                  <em></em>
                  <span>{{ item.industry_name }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-main>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      memberInfoRes: {},
      memberCompanyList: [],
      myAssociationListRes: [],
      colors: [
        "#528bce",
        "#43b2cd",
        "#527ba9",
        "#606cb8",
        "#4dbc70",
        "#13aa89",
      ],
      infoDetails: [
        {
          icon: require("../assets/images/enterprises-menu08.png"),
          menuName: "聯繫電話:",
          contentType: "mobilePhone",
        },
        {
          icon: require("../assets/images/enterprises-menu09.png"),
          menuName: "聯繫郵箱:",
          contentType: "email",
        },
        {
          icon: require("../assets/images/member-details01.png"),
          menuName: "個性簽名:",
          contentType: "personIntro",
        },
        {
          icon: require("../assets/images/member-details03.png"),
          menuName: "微信號碼:",
          contentType: "wechatId",
        },
        {
          icon: require("../assets/images/member-details02.png"),
          menuName: "Facebook:",
          contentType: "facebook",
        },
      ],
      memberCompanyList: [],
      myAssociationListRes: [],
    };
  },
  computed: {
    ...mapState(["infoRes", "isPc"]),
    memberName: function () {
      let vm = this;
      let member_name = vm.memberInfo.name || "";
      member_name = member_name.replace(/(^\s*)|(\s*)$/g, "");
      member_name = member_name.replace(/\（[^\）]*\）/g, "");
      member_name = member_name.replace(/\([^\)]*\)/g, "");
      return member_name;
    },
    memberInfo() {
      return {
        name: this.memberInfoRes.really_name,
        // mobilePhone:
        //   this.memberInfoRes.isopen && this.memberInfoRes.member_phone
        //     ? "******"
        //     : this.memberInfoRes.member_phone,
        mobilePhone: this.memberInfoRes.member_phone,
        email: this.memberInfoRes.member_email,
        address: this.memberInfoRes.member_address,
        wechatId: this.memberInfoRes.wechat_id,
        facebook: this.memberInfoRes.facebook,
        personIntro: this.memberInfoRes.person_intro,
        // photo: this.$imgUrl + this.memberInfoRes.member_photo,
        // checkPhoto: this.memberInfoRes.member_photo,
        isopen: this.memberInfoRes.isopen,
      };
    },
    infoIconList: function () {
      let vm = this;
      let keys = Object.keys(this.memberInfo);
      return this.infoDetails.map((item) => {
        keys.map((key) => {
          if (key === item.contentType) {
            item[key] = vm.memberInfo[key];
          }
        });
        return item;
      });
    },
  },
  methods: {
    async getAssociationMemberInfo() {
      const { data: res } = await this.$http.get(
        `/api/v2/association/SZTX/persons/${this.$route.params.member_id}`
      );
      // console.log(res.data);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.memberInfoRes = res.data;
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    async getMemberCompanyList() {
      const { data: res } = await this.$http.get(
        `/api/v2/member/${this.$route.params.member_id}/company`
      );
      // console.log(res.data);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.memberCompanyList = res.data;
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    fnToCompany(company_id) {
      this.$router.push({
        path: `/company/${company_id}`,
      });
    },
    // async getMyAssociationList() {
    //   const { data: res } = await this.$http.get(
    //     `/api/v2/member/${this.$route.params.member_id}/association`
    //   );
    //   // console.log(res.data);
    //   if (res.code !== "200") return this.$message.error(res.msg);
    //   this.myAssociationListRes=res.data
    // },
  },
  created() {
    this.getAssociationMemberInfo();
    this.getMemberCompanyList();
    // this.getMyAssociationList();
  },
};
</script>

<style lang="less" scoped>
.el-main {
  margin-top: 20px;
}
.member_details {
  .avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img {
      width: 80px !important;
      height: 120px !important;
      object-fit: contain;
    }
    h5 {
      font-size: 18px;
      color: #333333;
      line-height: 25px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-weight: bold;
      padding: 14px 0;
      text-align: center;
    }
    .bg-title {
      width: 100%;
      height: 120px;
      background: #bbbbbb;
      margin-right: 10px;
      font-size: 28px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    span {
      padding: 0 !important;
      line-height: 20px;
      font-size: 14px;
      color: #999999;
      margin-bottom: 20px;
    }
  }
  .info_list_item {
    .e-row {
      padding: 15px 0 0;
    }
    .tag-name {
      display: -webkit-flex; /* Safari */
      display: flex;
      align-items: center;
      /* justify-content: center; */
    }
    em {
      width: 24px;
      height: 24px;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      margin-right: 16px;
      vertical-align: middle;
    }
    label {
      font-size: 16px;
      color: #666;
      line-height: 24px;
      font-weight: normal;
    }
    span {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      line-height: 22px;
      display: flex;
      align-items: center;
      strong{
        font-size: 12px;
        color: #89C87A;
      }
      .red{
        color: #f12e2b;
      }
    }
    b {
      width: 40px;
      height: 40px;
      border-radius: 40px;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      /* margin-right: 16px; */
      vertical-align: middle;
    }
    i {
      font-size: 12px;
      color: #f12e2b;
      line-height: 13px;
      padding: 2px 5px;
      background: #ffe9e9;
      border-radius: 5px;
      white-space: nowrap;
      margin-left: 8px;
      font-weight: normal;
    }
  }
  .title01 {
    font-family: "PingFangSC-Regular";
    font-size: 18px;
    color: #666666;
    font-weight: normal;
    line-height: 20px;
    display: flex;
    margin-top: 16px;
    margin-bottom: 14px;
  }
  .title01::before {
    content: "";
    width: 24px;
    height: 24px;
    background: url("../assets/images/member-details04.png") no-repeat center
      center;
    background-size: contain;
    display: inline-block;
    margin-right: 8px;
  }
  .title02::before {
    background: url("../assets/images/member-details05.png") no-repeat center
      center;
    background-size: contain;
  }
  .grid-content {
    cursor: pointer;
    padding: 20px;
    display: flex;
    align-items: center;
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.04), 0 0 30px 0 rgba(0, 0, 0, 0.08);
    .el-image {
      width: 66px;
      height: 66px;
      margin-right: 15px;
    }
    .bg-title {
      width: 66px;
      height: 66px;
      line-height: 66px;
      background: #bbbbbb;
      border-radius: 10px;
      margin-right: 10px;
      font-size: 30px;
      color: #ffffff;
      text-align: center;
    }
    .company_title {
      flex: 1;
      h3 {
        font-size: 16px;
        color: #414141;
        line-height: 18px;
        margin-bottom: 14px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
        overflow: hidden;
      }
      .company_info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        div {
          display: flex;
          align-items: center;
          // min-width: 100px;
        }
        span {
          font-size: 12px;
          line-height: 14px;
          color: #656565;
          max-width: 100px;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          word-break: break-all;
          overflow: hidden;
        }
        em {
          display: inline-block;
          width: 20px;
          height: 20px;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          vertical-align: middle;
          margin-right: 8px;
        }
        .company_tel em {
          background-image: url("../assets/images/enterprises-menu08.png");
        }
        .company_field em {
          background-image: url("../assets/images/enterprises-menu04.png");
        }
      }
      p {
        font-size: 14px;
        line-height: 24px;
        height: 48px;
        color: #999999;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
        overflow: hidden;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .el-main {
    width: 100%;
    padding: 0 20px;
  }
}
.info_list_item .el-row {
  padding: 15px 0 0;
}
</style>
